import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function GuestRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (user) return <Navigate to="/app" replace />;

  return <>{children}</>;
}
